export default __webpack_public_path__ + "fonts/connect-promo-illustration-full.svg";